/***
 * Created on 2023/9/14
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalDialog from "../common/modal_dialog";
import {useTranslation} from "react-i18next";


function RegionSwitchWarning({mode, switchTo, submitAction, ...props}) {
    const { t } = useTranslation();

    const onSubmit= async () => {
        if (submitAction) {
            if (mode === 'switch_region') {
                submitAction(switchTo);
            }
            else {
                submitAction();
            }
        }
    }

    return (
        <ModalDialog {...props} title={t('@Warning@')} submitText={t('@OK@')} cancelText={t('@Not remind me today@')} submitAction={onSubmit}>
            <div className="dialog-content">
                {
                    mode === 'switch_region' &&
                    <p>{t('@Switching to the location may have poor network performance. Are you sure to continuous?@')}</p>
                }
                {
                    mode === 'region_mismatch' &&
                    <p>{t('@You are not using the suitable domain with best network performance. Do you want to change to the suggestion domain?@')}</p>
                }
                <p className="text-warning">{t('@Note: You need to sign in website again after switched.@')}</p>
            </div>
        </ModalDialog>
    );
}

export default RegionSwitchWarning;